import axios from "axios";
// import store from "@/store";
import base from "./base.js";
import { Toast } from "vant";
import router from "@/router";
// 创建axios实例
const service = axios.create({
  baseURL: base.requestURL,
  // baseURL: "http://139.9.223.42/",
  headers: {
    // 看是否需要携带token参数
    Authorization: ""
  }
  // timeout: 30000 // 请求超时时间
});

// 请求发出前的拦截器
service.interceptors.request.use(
  req => {
    // 这一段看需要增加或者删除;
    //判断本地是否存在token
    // var token = store.state.common.adminToken;
    // if (token != "") {
    //为header添加token
    // req.headers.Authorization = "JWT " + store.state.common.adminToken;
    req.headers.access_token = localStorage.token;
    // }
    return req;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应的拦截器
service.interceptors.response.use(
  function(response) {
    // const data = response.data;
    // if (data.code !== "0") {}

    return Promise.resolve(response.data);
  },
  function(error) {
    if (error.response) {
      // 看后端设置的错误码显示报错信息
      if (error.response.status == 404) {
        Toast("404,请求找不到！");
      } else if (error.response.status == 403 || error.response.status == 401) {
        Toast("无权限");
      } else {
        Toast("服务器错误！");
      }
    } else {
      // alert('未知错误，可能是断网了！');
    }
  }
);

export default service;
